function guardMyroute(to, from, next) {
    var isAuthenticated = false;

    var getAuth = localStorage.getItem('IsAuthenticated');
    if (getAuth === null) { isAuthenticated = false; }

    if (getAuth) {
        next();
    }
    else {
        next('/login')
    }


}

export default [
    {
        path: '',
        name: '',
        component: () => import("@/views/club/pages/ClubDashboard"),
    },
    {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import("@/views/club/pages/ClubDashboard"),
    },
    {
        path: 'scores',
        name: 'scores',
        component: () => import("@/views/club/pages/Scores"),
    },
    {
        path: 'transactions',
        name: 'transactions',
        component: () => import("@/views/club/pages/Transactions"),
    },
    {
        path: 'survey',
        name: 'survey',
        component: () => import("@/views/club/pages/Survey"),
    },
    { path: "**", redirect: "/" },
];
